module.exports = __webpack_public_path__ + "fa-brands-400.ttf?98b6db59be947f563350d2284fc9ea36";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fortawesome/fontawesome-free/webfonts/fa-brands-400.ttf
// module id = 225
// module chunks = 0